import React from "react";
import {BrandName} from "../../../constants";
import {ListItem, Paragraph, Title, Underline} from "../TermsText";

const ClosingTermsSection = () => {
  return (
    <>
      <Title>{"14. Assignment."}</Title>

      <Paragraph>
        {"You will not assign any of your rights or delegate any of your obligations under these Terms without our prior written consent. Any purported assignment or delegation in violation of this Section 14 is null and void. No assignment or delegation relieves you of any of your obligations under these Terms."}
      </Paragraph>

      <Title>{"15. No Waivers."}</Title>

      <Paragraph>
        {"The failure by us to enforce any right or provision of these Terms will not constitute a waiver of future enforcement of that right or provision. The waiver of any right or provision will be effective only if in writing and signed by a duly authorized representative of "}{BrandName}{"."}
      </Paragraph>

      <Title>{"16. No Third-Party Beneficiaries."}</Title>

      <Paragraph>
        {"These Terms do not and are not intended to confer any rights or remedies upon any person other than you."}
      </Paragraph>

      <Title>{"17. Notices."}</Title>

      <ListItem marker="(a)">
        <Underline>{"To You"}</Underline>{". We may provide any notice to you under these Terms by: (i) sending a message to the email address you provide or (ii) by posting to the Site. Notices sent by email will be effective when we send the email and notices we provide by posting will be effective upon posting. It is your responsibility to keep your email address current."}
      </ListItem>

      <ListItem marker="(b)" mb={15}>
        <Underline>{"To Us"}</Underline>{". To give us notice under these Terms, you must contact us as follows: (i) by personal delivery, overnight courier, or registered or certified mail to ["}{BrandName}{", 2575 S Highland Dr, Las Vegas, 89109]. We may update the facsimile number or address for notices to us by posting a notice on the Site. Notices provided by personal delivery will be effective immediately. Notices provided by overnight courier will be effective one business day after they are sent. Notices provided by registered or certified mail will be effective three business days after they are sent."}
      </ListItem>

      <Title>{"18. Severability."}</Title>

      <Paragraph>
        {"If any provision of these Terms is invalid, illegal, void or unenforceable, then that provision will be deemed severed from these Terms and will not affect the validity or enforceability of the remaining provisions of these Terms."}
      </Paragraph>

      <Title>{"19. Entire Agreement."}</Title>

      <Paragraph>
        {"These Terms, our Privacy Policy, and our Promotion Terms and Conditions will be deemed the final and integrated agreement between you and us on the matters contained in these Terms."}
      </Paragraph>
    </>
  );
};

export default React.memo(ClosingTermsSection);
